import { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { HelperConfig } from "../../Course/Helpers/Helpers";
import { useGetAllHelpers, useGetHelperDisplayOrder, useHasOpenHelpers, useHelperStore } from "../../Course/Helpers/HelperStore";
import { HelperState } from "../../Course/Helpers/HelperState";
import './OpenHelpers.scss'
import { ClassNames } from "../../Util/ClassNames";
import { BsGripHorizontal } from "react-icons/bs";

export function OpenHelpers(){
    const allHelpers:HelperConfig[] = useGetAllHelpers()
    const sortedHelperIndexes:number[][] = useGetHelperDisplayOrder()
    const hasOpenHelpers:boolean = useHasOpenHelpers()
    const openHelperNodes:React.ReactNode[] = []
    sortedHelperIndexes.forEach((helperInfo:number[], index:number)=>{
        const helper:HelperConfig = allHelpers[helperInfo[0]]
        openHelperNodes.push(<HelperWindow title={helper.title} key={index} index={index} children={helper.element}/>)
    })
    const scale:number = 1; //(openHelperNodes.length > 3 ) ? .8 : 1
    const nodeRef = useRef(null)
    const getClasses = () => {
        const classNames:ClassNames = new ClassNames(['open-helpers'])
        if(!hasOpenHelpers){ classNames.addClass('empty')}
        return(classNames.toString())
    }
    const [position, setPosition] = useState({x: 0, y: 0})
    const resetPosition = () => {
        if(!hasOpenHelpers){
            setPosition({x: 0, y: 0})
        }
    }
    useEffect(resetPosition, [hasOpenHelpers])
    return( 
        <Draggable 
                nodeRef={nodeRef} 
                position={position} 
                onStop={(e, data) => setPosition({ x: data.x, y: data.y })}
                bounds={{ top: 0, right: 0 }}
                handle=".helper-drag-handle"
                >
        <div ref={nodeRef} className={getClasses()}>
                <div className={'helper-drag-handle'}><BsGripHorizontal /></div>
                <div style={{scale:scale}} className={'open-helpers-container'}>
                    {openHelperNodes}
                </div>
        </div>
        </Draggable>
    )
}

export function HelperWindowCloser(props:{title:string}){
    const closer:Function =  useHelperStore((state:HelperState)=>state.closeHelper)
    const onCloseClick = () => {closer(props.title)}
    return(<div className={'helper-window-closer'} onClick={onCloseClick}>x</div>)
}
export function HelperWindow(props:{title:string, index:number, children:React.ReactNode}){
        
        return( 
            <div className='helper-window-shell'>
                <div className={'helper-title'}>{props.title}</div>
                <HelperWindowCloser title={props.title}/>
                {props.children}
            </div>
        )
}